import { render, staticRenderFns } from "./EvaluationPriority.vue?vue&type=template&id=09fa1ce5&lang=pug&"
import script from "./EvaluationPriority.vue?vue&type=script&lang=js&"
export * from "./EvaluationPriority.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationPriority.vue?vue&type=style&index=0&id=09fa1ce5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports